import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { withFocus, focusManager } from '@accedo/vdkweb-navigation';
import { useDispatch, useSelector } from 'react-redux';
import styles from './AvatarModalTV.scss';
import { Avatar, LayoutX } from '#/widgets/ui';
import BaseModal from '../../common/BaseModal/BaseModal';
import FocusModal from '../../common/FocusModal/FocusModal';
import { AVATARMODAL } from '#/utils/navigationHelper';
import { actions } from '#/redux/modules/modal/actions';

import { getDraftProfile } from '#/redux/modules/onboarding/selectors';
import { getModalData } from '#/redux/modules/modal/selectors';

import { getAvatars } from '#/redux/modules/firestore/selectors';

const FocusSpan = withFocus(({ isFocused, className, nav, ...props }) => (
  <div
    {...props}
    id={nav.id}
    className={cx(className, styles.avatar, { [styles.focused]: isFocused })}
  />
));

const AvatarModalTV = ({ successAction }) => {
  const dispatch = useDispatch();
  const profile = useSelector(getDraftProfile);
  const fieldOptions = useSelector(getAvatars);
  const { returnFocus } = useSelector(state => getModalData(state));
  const fieldSelected = profile.avatar;
  const [selected, setSelected] = useState(fieldSelected);

  const keyIds = fieldOptions.map((el, i) => `key-${i}`);
  const layout = keyIds.reduce((a, b, i) =>
    i % 4 === 0 ? `${a}\n${b}` : `${a} ${b}`,
  );

  useEffect(() => {
    focusManager.changeFocus(
      AVATARMODAL.SELECT,
      // AVATARMODAL.navOverride.id,
    );
  }, []);

  const onSave = () => {
    if (selected !== null) {
      successAction.payload = selected;
      dispatch(successAction);
    }
    focusManager.changeFocus(returnFocus);
    dispatch(actions.closeModal());
  };

  const optionsButtons = Object.entries(fieldOptions).map(([k, v]) => (
    <FocusSpan
      key={k}
      nav={{ id: keyIds[k] }}
      onClick={() => {
        setSelected(v);
      }}
      className={{ [styles.selected]: selected === v }}
    >
      <Avatar profile={{ avatar: v }} />
    </FocusSpan>
  ));

  return (
    <FocusModal>
      <BaseModal
        className={styles.content}
        showSaveButton
        saveButtonText="Save"
        saveButtonClassName={styles.saveButton}
        saveButtonDisabled={!selected}
        saveAction={() => () => onSave()}
        nav={{
          id: AVATARMODAL.navOverride.id,
          parent: AVATARMODAL.navOverride.parent,
          nextup: AVATARMODAL.SELECT,
        }}
      >
        <h2 className={styles.title}>Pick a profile icon</h2>
        <LayoutX
          className={styles.avatarModalContent}
          nav={{
            id: AVATARMODAL.SELECT,
            forwardFocus: 'key-0',
            useLastFocus: true,
            nextdown: selected && AVATARMODAL.SAVE_BUTTON,
          }}
          layout={layout}
        >
          {optionsButtons}
        </LayoutX>
      </BaseModal>
    </FocusModal>
  );
};

AvatarModalTV.propTypes = {
  successAction: PropTypes.object,
};

export default AvatarModalTV;
